const React = require("react");

function PaperAirplaneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
  }));
}

module.exports = PaperAirplaneIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/PaperAirplaneIcon.js
 ** module id = 574
 ** module chunks = 0
 **/